import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProductionItemRequestCompletedActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemRequest/ItemRequestHistoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="ItemRequestCompleted"
				RenderedComponent={this.RenderedComponent}
				context="complete"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductionItemRequestCompletedActivity)
